export default {
  "fontElementMap": "QiJAI",
  "elementSpacing": "ZPZWP",
  "text": "lcDvi ZPZWP",
  "child": "D7n8k"
};